import { useQuery, useMutation, useQueryClient, keepPreviousData } from '@tanstack/react-query';
import financeService from '../../services/financeService';

const KEY = ['finance'];

export function useFinanceDashboard() {
  return useQuery({
    queryKey: [...KEY, 'dashboard'],
    queryFn: financeService.getDashboard,
    staleTime: 60_000,
  });
}

export function useFinanceList(filters) {
  return useQuery({
    queryKey: [...KEY, 'list', filters],
    queryFn: () => financeService.listAppointments(filters),
    enabled: !!filters?.startDate && !!filters?.endDate,
    placeholderData: keepPreviousData,
  });
}

export function useFinanceDetails(appointmentId) {
  return useQuery({
    queryKey: [...KEY, 'details', appointmentId],
    queryFn: () => financeService.getDetails(appointmentId),
    enabled: !!appointmentId,
  });
}

export function useFinanceSave() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, payload }) => financeService.save(id, payload),
    onSuccess: (_data, vars) => {
      qc.invalidateQueries({ queryKey: [...KEY, 'dashboard'] });
      qc.invalidateQueries({ queryKey: [...KEY, 'list'] });
      qc.invalidateQueries({ queryKey: [...KEY, 'details', vars.id] });
      // Também invalidar schedules/professionals se promoteDefault foi true:
      qc.invalidateQueries({ queryKey: ['schedules'] });
    },
  });
}
